const LGPD = function () {

    
    const checkLGPD = () => {

        const cookies = document.cookie.split('; ');
    
        let response = '';
        $.each(cookies, function (key, cookie) {
            cookie = cookie.split("=");
            let index = cookie[0];
    
            if (index.indexOf("lgpdArN") >= 0) {
                response = cookie[1];
            }
        });
    
        if(response == 'true') {
            $(".lgpd").css('display','none');
        }

    }

    return {

        init : () => {

            checkLGPD();

            $(document).on('click', '.accept-lgpd', function(){
                document.cookie = "lgpdArN=true";            
                $('.lgpd').slideUp();
            });

        }

    }

}();

module.exports = LGPD;